var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',_vm._g({attrs:{"role":"form"}},_vm.$listeners),[(_vm.hasRequiredFields)?_c('p',{staticClass:"form-requirements screen-reader-text"},[_vm._v(" ("+_vm._s(_vm.translate("Fields marked with an asterisk (*) are required"))+") ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }